import React, { useEffect, useState } from 'react';
import ReactSound from 'react-sound';
import styled from 'styled-components';

import { useImagesContext } from '../../../contexts/ImagesContext';

import { connect } from 'react-redux';
import UIFx from 'uifx';
import { backToMainPage, setBirdEnergy } from '../../../actions/hatch-egg';
import { playUpdate } from '../../../services/game-play';
import { Delay } from '../../../utils/delay';
import { ImgClick } from '../../utility';

import { useRef } from 'react';
import Img from 'react-image';
import AnimationWithSound from '../AnimationWithSound';
import soundBackground1 from '../sounds/play-background-1.mp3';
import soundBackground2 from '../sounds/play-background-2.mp3';
import soundBackground3 from '../sounds/play-background-3.mp3';
import soundBackground4 from '../sounds/play-background-4.mp3';
import soundBackground5 from '../sounds/play-background-5.mp3';
import soundBeingDead from '../sounds/play-being-dead.mp3';
import endGameStart from '../sounds/play-endgame-start.mp3';
import soundIntro from '../sounds/play-intro.mp3';
import soundPass from '../sounds/play-pass.mp3';
import soundStonePlaced from '../sounds/play-stone-placed.mp3';
import Boss, { BOSS_STATE } from './Boss';
import BossEgg, { BOSS_EGG } from './BossEgg';
import BossLampArsenal, { BOSS_LAMP_ARSENAL_STATE } from './BossLampArsenal';
import BossSoul, { BOSS_SOUL_STATE } from './BossSoul';
import PlayBoard, { STONE_STATE } from './PlayBoard';
import { PlayEngine } from './PlayEngine';
import Player, { PLAYER_STATE } from './Player';
import PlayerEgg, { PLAYER_EGG } from './PlayerEgg';
import PlayerLampArsenal, {
  PLAYER_LAMP_ARSENAL_STATE,
} from './PlayerLampArsenal';
import PlayerSoul, { PLAYER_SOUL_STATE } from './PlayerSoul';
import Score from './Score';

import resingSound from '../sounds/play-resign.mp3';
import moreCaptureSound from '../sounds/play-more-capture.ogg';
import undoSound from '../sounds/play-undo.mp3';

const EFFECT_STAGE = {
  NONE: 0,
  INTRO: 1,
  PLAYER_INTRO: 2,
  READY: 3,
  RUNAWAY: 4,
  DISPLAY_SCORE: 5,
  PROCESS_ENDGAME: 6,
  END_GAME: 7,
};

const PLAY_STATE = {
  WAITING_BEGINING: 0,
  WAITING_HUMAN_PLAY: 1,
  WAITING_AI_PLAY: 2,
  WAITING_SERVER_RESPONSE: 3,
  SERVER_RESPONSE: 4,
};

const CAPTURED_IMAGE = {
  NORMAL: 0,
  TRIPLE: 1,
  EXCELLENT: 2,
  FANTASTIC: 3,
};

const PLAY_STATE_NAMES = {
  0: 'WAITING_BEGINING',
  1: 'WAITING_HUMAN_PLAY',
  2: 'WAITING_AI_PLAY',
  3: 'WAITING_SERVER_RESPONSE',
  4: 'SERVER_RESPONSE',
};

const AI_PROCESSING_DELAY_MS = 1000;
const ENDGAME_START_DELAY_MS = 3000;

const backgroundSound = (config, stageNumber) => {
  console.debug(
    `backgroundSound: stageNumber=${stageNumber}, config=${config}`,
  );
  if (stageNumber === null) return null;
  let sound = null;
  switch (stageNumber) {
    case 1:
      sound = soundBackground1;
      break;
    case 2:
      sound = soundBackground2;
      break;
    case 3:
      sound = soundBackground3;
      break;
    case 4:
      sound = soundBackground4;
      break;
    case 5:
      sound = soundBackground5;
      break;
    default:
      sound = soundBackground1;
  }
  return (
    <>
      {config.isMutedSound === false && (
        <ReactSound url={sound} playStatus="PLAYING" loop={true}></ReactSound>
      )}
    </>
  );
};

const PlayPage = ({
  config,
  backToMainPage,
  stageNumber,
  playId,
  student,
  birdEnergy,
  setBirdEnergy,
}) => {
  const { images } = useImagesContext();
  const [effectStage, setEffectStage] = useState(EFFECT_STAGE.NONE);
  const [showBoard, setShowBoard] = useState(false);

  const requestTime = React.useRef(0);
  const [playState, setPlayState] = useState(PLAY_STATE.WAITING_BEGINING);
  const [playerPassed, setPlayerPassed] = useState(false);
  const [bossPassed, setBossPassed] = useState(false);
  const [playerState, setPlayerState] = useState(PLAYER_STATE.NOT_DISPLAYED);
  const [bossState, setBossState] = useState(BOSS_STATE.FIGHTING);
  const [playerSoulState, setPlayerSoulState] = useState(
    PLAYER_SOUL_STATE.NORMAL,
  );
  const [bossSoulState, setBossSoulState] = useState(BOSS_SOUL_STATE.NORMAL);
  const [playerEggState, setPlayerEggState] = useState(PLAYER_EGG.NORMAL);
  const [bossEggState, setBossEggState] = useState(BOSS_EGG.NORMAL);
  const [playerLampArsenalState, setPlayerLampArsenalState] = useState(
    PLAYER_LAMP_ARSENAL_STATE.DISPLAY,
  );
  const [bossLampArsenalState, setBossLampArsenalState] = useState(
    BOSS_LAMP_ARSENAL_STATE.DISPLAY,
  );
  const [displaySpawningTime, setDisplaySpawningTime] = useState(false);
  const [stones, setStones] = useState([]);
  const [capturedImage, setCapturedImage] = useState(CAPTURED_IMAGE.NORMAL);
  const passCountRef = useRef(0);
  const [blackTerritoryValue, setBlackTerritoryValue] = useState(0);
  const [whiteTerritoryValue, setWhiteTerritoryValue] = useState(0);
  const [isResigned, setIsResigned] = useState(false);
  const [blackCaptureValue, setBlackCaptureValue] = useState(0);
  const [whiteCaptureValue, setWhiteCaptureValue] = useState(0);

  const data = useRef({
    blackLegals: [],
    whiteLegals: [],
    blackCapture: 0,
    whiteCapture: 0,
    blackTerritory: 0,
    whiteTerritory: 0,
    stones: [],
    soulAmount: 0,
    eggAmount: 0,
    blackTerritories: [],
    whiteTerritories: [],
  });
  const engineRef = React.useRef(null);

  console.debug(
    `PlayPage render: playState=${
      PLAY_STATE_NAMES[playState]
    }, data=${JSON.stringify(data.current)}`,
  );

  const getStones = ({ blackStones, whiteStones }) => {
    return [
      ...(blackStones
        ? blackStones.split(' ').map((vertex) => ({
            vertex,
            color: 'B',
            state: STONE_STATE.NORMAL,
          }))
        : []),
      ...(whiteStones
        ? whiteStones.split(' ').map((vertex) => ({
            vertex,
            color: 'W',
            state: STONE_STATE.NORMAL,
          }))
        : []),
    ];
  };

  const handleOnBegin = ({
    blackCapture,
    whiteCapture,
    blackStones,
    whiteStones,
    blackLegals,
    whiteLegals,
  }) => {
    console.debug(
      `handleOnBegin: ${JSON.stringify({
        blackCapture,
        whiteCapture,
        blackStones,
        whiteStones,
        blackLegals,
        whiteLegals,
      })}`,
    );
    data.current.blackLegals = blackLegals.split(' ');
    data.current.whiteLegals = whiteLegals.split(' ');
    data.current.stones = getStones({ blackStones, whiteStones });
    data.current.blackCapture = blackCapture;
    setBlackCaptureValue(blackCapture);
    data.current.whiteCapture = whiteCapture;
    setWhiteCaptureValue(whiteCapture);
    setPlayState(PLAY_STATE.WAITING_HUMAN_PLAY);
  };

  const resignProcess = async () => {
    setIsResigned(true);
    setBossState(BOSS_STATE.LOSE);
    playUpdate(student.id, 30, 20);
    setBirdEnergy(birdEnergy - 1);
  };

  const resingEnd = async () => {
    await Delay(5000);
    backToMainPage();
  };

  const handleOnMove = async ({
    color,
    vertex,
    blackCapture,
    whiteCapture,
    blackStones,
    whiteStones,
    blackLegals,
    whiteLegals,
  }) => {
    console.debug(
      `handleOnMove: ${JSON.stringify({
        color,
        vertex,
        blackCapture,
        whiteCapture,
        blackStones,
        whiteStones,
        blackLegals,
        whiteLegals,
      })}`,
    );

    if (vertex === 'PASS' && color === 'W') {
      setBossPassed(true);
      await Delay(2000);
      setBossPassed(false);
      passCountRef.current += 1;
      if (passCountRef.current >= 2) {
        handleEndGame();
      } else {
        setPlayState(PLAY_STATE.WAITING_HUMAN_PLAY);
      }
      return;
    }

    if (vertex.toLowerCase() === 'resign' && color === 'W') {
      resignProcess();
      return;
    }

    passCountRef.current = 0;

    const updateStones = getStones({ blackStones, whiteStones });

    const killedStones = data.current.stones.filter(
      (s) => !updateStones.find((us) => us.vertex === s.vertex),
    );
    const unionStones = [...updateStones, ...killedStones];
    const oldActiveStone = unionStones.find(
      (s) => s.state === STONE_STATE.ACTIVE,
    );
    if (oldActiveStone) {
      oldActiveStone.state = STONE_STATE.NORMAL;
    }
    const activeStone = unionStones.find((s) => s.vertex === vertex);
    if (activeStone) {
      activeStone.state = STONE_STATE.ACTIVE;
    }
    const responseTime = Date.now();
    console.debug(`requestTime=${requestTime.current} ms`);
    console.debug(`responseTime=${responseTime} ms`);
    const usedTime = responseTime - requestTime.current;
    data.current.blackLegals = blackLegals.split(' ');
    data.current.whiteLegals = whiteLegals.split(' ');

    console.debug(`usedTime=${usedTime} ms`);
    if (usedTime < AI_PROCESSING_DELAY_MS && color === 'W') {
      // if (usedTime < AI_PROCESSING_DELAY_MS) {
      await Delay(AI_PROCESSING_DELAY_MS - usedTime);
    }
    playSound(soundStonePlaced);
    data.current.stones = unionStones;
    setStones(unionStones);
    if (killedStones.length > 0) {
      await Delay(500);
      const captureStones = [
        ...updateStones,
        ...killedStones.map((s) => ({
          ...s,
          state: STONE_STATE.CAPTURED,
        })),
      ];

      data.current.stones = captureStones;
      setStones(captureStones);
      playSound(soundBeingDead);
      await Delay(500);
      data.current.stones = updateStones;
      setStones(updateStones);
      if (killedStones.length >= 3 && color === 'B') {
        if (killedStones.length > 5) {
          setCapturedImage(CAPTURED_IMAGE.FANTASTIC);
        } else if (killedStones.length > 3) {
          setCapturedImage(CAPTURED_IMAGE.EXCELLENT);
        } else if (killedStones.length === 3) {
          setCapturedImage(CAPTURED_IMAGE.TRIPLE);
        }
        await Delay(1000);
        setCapturedImage(CAPTURED_IMAGE.NORMAL);
      }
      if (color === 'B') {
        setPlayerSoulState(PLAYER_SOUL_STATE.INCREASING);
        await Delay(1000);
      } else if (color === 'W') {
        setBossSoulState(BOSS_SOUL_STATE.INCREASING);
        await Delay(1000);
      }
      setPlayerSoulState(PLAYER_SOUL_STATE.NORMAL);
      setBossSoulState(BOSS_SOUL_STATE.NORMAL);
      data.current.blackCapture = blackCapture;
      setBlackCaptureValue(blackCapture);
      data.current.whiteCapture = whiteCapture;
      setWhiteCaptureValue(whiteCapture);
    }
    if (color === 'W') {
      setPlayState(PLAY_STATE.WAITING_HUMAN_PLAY);
    } else if (color === 'B') {
      const requestTimeValue = Date.now();
      console.debug('setRequestTime=', requestTimeValue);
      requestTime.current = requestTimeValue;
      setPlayState(PLAY_STATE.WAITING_AI_PLAY);
      engineRef.current.genMove({ color: 'W' });
    }
  };

  const handleOnUndo = async ({
    color,
    vertex,
    blackCapture,
    whiteCapture,
    blackStones,
    whiteStones,
    blackLegals,
    whiteLegals,
  }) => {
    console.debug(
      `handleOnUndo: ${JSON.stringify({
        color,
        vertex,
        blackCapture,
        whiteCapture,
        blackStones,
        whiteStones,
        blackLegals,
        whiteLegals,
      })}`,
    );

    if (vertex === 'PASS' && color === 'W') {
      setBossPassed(true);
      await Delay(2000);
      setBossPassed(false);
      return;
    }

    const updateStones = getStones({ blackStones, whiteStones });

    const activeStone = updateStones.find((s) => s.vertex === vertex);
    if (activeStone) {
      activeStone.state = STONE_STATE.ACTIVE;
    }
    const responseTime = Date.now();
    console.debug(`requestTime=${requestTime.current} ms`);
    console.debug(`responseTime=${responseTime} ms`);
    const usedTime = responseTime - requestTime.current;
    data.current.blackLegals = blackLegals.split(' ');
    data.current.whiteLegals = whiteLegals.split(' ');
    data.current.blackCapture = blackCapture;
    setBlackCaptureValue(blackCapture);
    data.current.whiteCapture = whiteCapture;
    setWhiteCaptureValue(whiteCapture);
    console.debug(`usedTime=${usedTime} ms`);
    if (usedTime < AI_PROCESSING_DELAY_MS && color === 'W') {
      await Delay(AI_PROCESSING_DELAY_MS - usedTime);
    }
    data.current.stones = updateStones;
    console.debug('After undo, stones=', data.current.stones);
    setStones(updateStones);
    setPlayState(PLAY_STATE.WAITING_HUMAN_PLAY);
  };

  const handleHumanPlay = (vertex) => {
    console.debug(`handleHumanPlay: vertex=${vertex}`);
    console.debug('blackLegals=', data.current.blackLegals);
    if (!engineRef.current) return;
    console.debug('Current playState=', playState);
    if (playState !== PLAY_STATE.WAITING_HUMAN_PLAY) return;
    if (data.current.blackLegals.includes(vertex)) {
      const oldActiveStone = data.current.stones.find(
        (s) => s.state === STONE_STATE.ACTIVE,
      );
      if (oldActiveStone) {
        oldActiveStone.state = STONE_STATE.NORMAL;
      }
      passCountRef.current = 0;
      data.current.stones = [
        ...data.current.stones,
        { color: 'B', vertex, state: STONE_STATE.ACTIVE },
      ];
      setPlayState(PLAY_STATE.WAITING_SERVER_RESPONSE);
      const requestTimeValue = Date.now();
      console.debug('setRequestTime=', requestTimeValue);
      requestTime.current = requestTimeValue;
      engineRef.current.handleHumanPlay({ vertex, color: 'B' });
    }
  };

  const getValueWithBonus = (value) => {
    if (value <= 0) return value;
    return Math.floor((1 + (stageNumber - 1) * 0.1) * value);
  };

  const handleHumanPass = () => {
    if (
      effectStage !== EFFECT_STAGE.READY ||
      playState !== PLAY_STATE.WAITING_HUMAN_PLAY
    )
      return;
    setPlayerPassed(true);
    const requestTimeValue = Date.now();
    console.debug('setRequestTime=', requestTimeValue);
    requestTime.current = requestTimeValue;
    setPlayState(PLAY_STATE.WAITING_AI_PLAY);
    setTimeout(() => {
      setPlayerPassed(false);
      passCountRef.current += 1;
      if (passCountRef.current >= 2) {
        handleEndGame();
      } else {
        engineRef.current.genMove({ color: 'W' });
      }
    }, 2000);
  };

  const playSound = (soundFile) => {
    if (config.isMutedSound === false) {
      const sound = new UIFx(soundFile);
      sound.play();
    }
  };

  const handleOnEndGame = async ({
    score,
    dead,
    blackTerritory,
    whiteTerritory,
    blackCapture,
    whiteCapture,
  }) => {
    console.debug('handleOnEndGame called:', {
      score,
      dead,
      blackTerritory,
      whiteTerritory,
      blackCapture,
      whiteCapture,
    });
    const responseTime = Date.now();
    const usedTime = responseTime - requestTime.current;
    if (usedTime < ENDGAME_START_DELAY_MS) {
      await Delay(ENDGAME_START_DELAY_MS - usedTime);
    }
    setPlayState(PLAY_STATE.SERVER_RESPONSE);
    setDisplaySpawningTime(false);
    const deadList = dead ? dead.split(/[ \n]/) : [];
    const deadStones = data.current.stones.filter((s) =>
      deadList.includes(s.vertex),
    );
    let blackCaptureCount = 0;
    let whiteCaptureCount = 0;
    let blackTerritories = [];
    let whiteTerritories = [];
    deadStones.forEach((s) => {
      s.state = STONE_STATE.CAPTURED;
      if (s.color === 'B') {
        whiteCaptureCount += 1;
        whiteTerritories.push(s.vertex);
      } else if (s.color === 'W') {
        blackCaptureCount += 1;
        blackTerritories.push(s.vertex);
      }
    });
    if (deadStones.length > 0) {
      await Delay(2000);
      playSound(soundBeingDead);
      setStones([...data.current.stones]);
      await Delay(1000);
      if (blackCaptureCount > 0) {
        setPlayerSoulState(BOSS_SOUL_STATE.INCREASING);
      }
      if (whiteCaptureCount > 0) {
        setBossSoulState(PLAYER_SOUL_STATE.INCREASING);
      }
      data.current.stones = [
        ...data.current.stones.filter((s) => !deadStones.includes(s)),
      ];
      setStones(data.current.stones);
      await Delay(1000);
      data.current.blackCapture = blackCapture
        ? parseInt(blackCapture) + blackCaptureCount
        : blackCaptureCount;
      setBlackCaptureValue(data.current.blackCapture);
      data.current.whiteCapture = whiteCapture
        ? parseInt(whiteCapture) + whiteCaptureCount
        : whiteCaptureCount;
      setWhiteCaptureValue(data.current.whiteCapture);
      setPlayerSoulState(PLAYER_SOUL_STATE.NORMAL);
      setBossSoulState(BOSS_SOUL_STATE.NORMAL);
      await Delay(1000);
    }

    console.debug('Territories:', {
      blackTerritory,
      whiteTerritory,
    });

    blackTerritories = blackTerritories.concat(
      blackTerritory ? blackTerritory.split(' ') : [],
    );
    whiteTerritories = whiteTerritories.concat(
      whiteTerritory ? whiteTerritory.split(' ') : [],
    );

    console.debug('Final Territories:', {
      blackTerritories,
      whiteTerritories,
    });

    blackTerritories.sort((a, b) => (a < b ? -1 : 1));
    whiteTerritories.sort((a, b) => (a < b ? 1 : -1));

    for (let v of blackTerritories) {
      data.current.stones.push({
        vertex: v,
        color: 'B',
        state: STONE_STATE.TERRITORY,
      });
      data.current.blackTerritory += 1;
      setBlackTerritoryValue(data.current.blackTerritory);
      setStones([...data.current.stones]);
      playSound(soundStonePlaced);
      await Delay(500);
    }
    for (let v of whiteTerritories) {
      data.current.stones.push({
        vertex: v,
        color: 'W',
        state: STONE_STATE.TERRITORY,
      });
      data.current.whiteTerritory += 1;
      setWhiteTerritoryValue(data.current.whiteTerritory);
      setStones([...data.current.stones]);
      playSound(soundStonePlaced);
      await Delay(500);
    }

    setEffectStage(EFFECT_STAGE.END_GAME);
    // await Delay(3000);
  };

  const handleEndGameEffectStart = async () => {
    // Player's turn to shoot
    if (data.current.blackCapture > 0) {
      setBlackCaptureValue(0);
      setPlayerLampArsenalState(PLAYER_LAMP_ARSENAL_STATE.SHOOT);
    } else {
      setPlayerLampArsenalState(PLAYER_LAMP_ARSENAL_STATE.NOT_SHOOT);
    }
  };

  const handlePlayerShootFinished = async () => {
    setPlayerLampArsenalState(PLAYER_LAMP_ARSENAL_STATE.DISPLAY);

    for (let i = 0; i < data.current.blackCapture; i++) {
      data.current.whiteTerritory -= 1;
      setWhiteTerritoryValue(data.current.whiteTerritory);
      if (data.current.whiteTerritory === 0) {
        break;
      }
      await Delay(100);
    }
    if (data.current.whiteTerritory <= 0) {
      setBossEggState(BOSS_EGG.BROKEN);
      await Delay(3000);
    }

    // Boss's turn to shoot
    if (data.current.whiteCapture > 0) {
      setWhiteCaptureValue(0);
      setBossLampArsenalState(BOSS_LAMP_ARSENAL_STATE.SHOOT);
    } else {
      setBossLampArsenalState(BOSS_LAMP_ARSENAL_STATE.NOT_SHOOT);
    }
  };

  const handleBossShootFinished = async () => {
    setBossLampArsenalState(BOSS_LAMP_ARSENAL_STATE.DISPLAY);
    for (let i = 0; i < data.current.whiteCapture; i++) {
      data.current.blackTerritory -= 1;
      setBlackTerritoryValue(data.current.blackTerritory);
      if (data.current.blackTerritory === 0) {
        break;
      }
      await Delay(100);
    }
    if (data.current.blackTerritory <= 0) {
      setPlayerEggState(PLAYER_EGG.BROKEN);
      await Delay(3000);
    } else {
      setPlayerEggState(PLAYER_EGG.NORMAL);
    }
    data.current.eggAmount = getValueWithBonus(data.current.blackTerritory);
    data.current.soulAmount = getValueWithBonus(data.current.blackCapture);
    setEffectStage(EFFECT_STAGE.DISPLAY_SCORE);
    if (data.current.blackTerritory > data.current.whiteTerritory) {
      setBossState(BOSS_STATE.LOSE);
    }
    if (data.current.whiteTerritory > data.current.blackTerritory) {
      setPlayerState(PLAYER_STATE.LOSE);
    }
    playUpdate(
      student.id,
      data.current.soulAmount,
      Math.max(0, data.current.eggAmount),
    );
    setBirdEnergy(birdEnergy - 1);
    await Delay(5000);
    backToMainPage();
  };

  const handleEndGame = () => {
    setEffectStage(EFFECT_STAGE.PROCESS_ENDGAME);
    const activeStone = data.current.stones.find(
      (s) => s.state === STONE_STATE.ACTIVE,
    );
    if (activeStone) {
      activeStone.state = STONE_STATE.NORMAL;
    }

    setPlayState(PLAY_STATE.WAITING_SERVER_RESPONSE);
    requestTime.current = Date.now();
    engineRef.current.endGame();
    setDisplaySpawningTime(true);
  };

  const handleEndGameDisplay = () => {
    if (effectStage !== EFFECT_STAGE.END_GAME) return;
    handleEndGameEffectStart();
  };

  const handleIntroFinish = async () => {
    setShowBoard(true);
    setPlayerState(PLAYER_STATE.FIGHTING_START);
    setEffectStage(EFFECT_STAGE.READY);
    await Delay(2000);
    setPlayerState(PLAYER_STATE.FIGHTING);
    setEffectStage(EFFECT_STAGE.READY);
    setPlayerLampArsenalState(PLAYER_LAMP_ARSENAL_STATE.FIGHTING);
    setBossLampArsenalState(BOSS_LAMP_ARSENAL_STATE.FIGHTING);
  };

  useEffect(() => {
    if (playState !== PLAY_STATE.WAITING_BEGINING) {
      return;
    }
    engineRef.current = new PlayEngine({
      level: stageNumber,
      hostUrl:
        window.location.hostname === 'localhost'
          ? 'http://localhost:8090'
          : `${window.location.origin}`,
      onMove: handleOnMove,
      onBegin: handleOnBegin,
      onEndGame: handleOnEndGame,
      onUndo: handleOnUndo,
    });

    setEffectStage(EFFECT_STAGE.INTRO);
    engineRef.current.joinRoom(playId);
    // setShowBoard(true);
    return () => {
      if (engineRef.current) engineRef.current.disconnect();
    };
  }, []);

  return (
    <Container>
      <Background src={images[`play-background-${stageNumber}.jpg`]} />
      <Board
        $zIndex={showBoard ? 0 : -1}
        src={images[`play-board-${stageNumber}.png`]}
      />
      <PlayerSoul amount={blackCaptureValue} state={playerSoulState} />
      <BossSoul amount={whiteCaptureValue} state={bossSoulState} />
      <PlayerEgg amount={blackTerritoryValue} state={playerEggState} />
      <BossEgg amount={whiteTerritoryValue} state={bossEggState} />
      <RunButton
        src={images['play-run.png']}
        onClick={() => {
          console.debug('Run button click');
          if (effectStage !== EFFECT_STAGE.READY) return;
          setPlayerState(PLAYER_STATE.RUNAWAY);
          setEffectStage(EFFECT_STAGE.RUNAWAY);
          // setTimeout(() => {
          //   backToMainPage();
          // }, 3000);
        }}
        $visible={effectStage === EFFECT_STAGE.READY}
      />
      {(effectStage === EFFECT_STAGE.READY ||
        effectStage === EFFECT_STAGE.PROCESS_ENDGAME ||
        effectStage === EFFECT_STAGE.END_GAME ||
        effectStage === EFFECT_STAGE.RUNAWAY) && (
        <PlayBlock $zIndex={effectStage === EFFECT_STAGE.READY ? 1 : 0}>
          <UndoButton
            src={images['play-undo.png']}
            onClick={() => {
              console.debug('Undo button clicked');
              // setPlayerState(PLAYER_STATE.FIGHTING_START);
              // setTimeout(() => {
              //   setPlayerState(PLAYER_STATE.FIGHTING);
              // }, 1000);
              // setTimeout(() => {
              //   setPlayerState(PLAYER_STATE.FIGHTING_START);
              // }, 2000);
              // setTimeout(() => {
              //   setPlayerState(PLAYER_STATE.FIGHTING);
              // }, 3000);
              if (stones.length === 0) return;
              engineRef.current.undo();
              playSound(undoSound);
            }}
          />
          <PlayBoard
            stageNumber={stageNumber}
            stones={stones}
            handlePlayerStonePlace={handleHumanPlay}
          />
        </PlayBlock>
      )}
      <PlayerLampArsenal
        state={playerLampArsenalState}
        handleOnClick={() => {
          handleEndGameDisplay();
        }}
        onShootCompleted={() => {
          handlePlayerShootFinished();
        }}
      />
      <BossLampArsenal
        state={bossLampArsenalState}
        handleOnClick={() => {
          // handleEndGame();
        }}
        onShootCompleted={handleBossShootFinished}
      />
      {displaySpawningTime && (
        <AnimationWithSound
          imageUrl={images[`play-endgame.png`]}
          soundFile={endGameStart}
          playSound={!config.isMutedSound}
          style={{
            width: '1200px',
            height: '330px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          zIndex={1}
        />
      )}
      {effectStage === EFFECT_STAGE.READY && (
        <>{backgroundSound(config, stageNumber)}</>
      )}
      {effectStage === EFFECT_STAGE.INTRO && (
        <AnimationWithSound
          imageUrl={images[`play-board-intro-${stageNumber}.png`]}
          soundFile={soundIntro}
          playSound={!config.isMutedSound}
          onSoundEnd={() => {
            console.debug('Intro animation ended');
            handleIntroFinish();
          }}
        />
      )}
      {effectStage === EFFECT_STAGE.DISPLAY_SCORE && (
        <Score
          stageNumber={stageNumber}
          soulAmount={data.current.soulAmount}
          eggAmount={data.current.eggAmount}
        />
      )}
      <Player
        images={images}
        state={playerState}
        handleOnDoubleClick={() => {
          console.debug('Player double clicked');
          handleHumanPass();
        }}
        handleOnRunaway={() => {
          backToMainPage();
        }}
      />
      <Boss images={images} state={bossState} stageNumber={stageNumber} />
      {playerPassed && (
        <>
          <PlayerPass src={images['play-player-pass.png']} />
          <ReactSound
            url={soundPass}
            playStatus={config.isMutedSound ? 'STOPPED' : 'PLAYING'}
            loop={false}
          ></ReactSound>
        </>
      )}
      {bossPassed && (
        <>
          <BossPass src={images['play-boss-pass.png']} />
          <ReactSound
            url={soundPass}
            playStatus={config.isMutedSound ? 'STOPPED' : 'PLAYING'}
            loop={false}
          ></ReactSound>
        </>
      )}
      {capturedImage === CAPTURED_IMAGE.TRIPLE && (
        <AnimationWithSound
          imageUrl={images['play-triple.png']}
          soundFile={moreCaptureSound}
          playSound={!config.isMutedSound}
          zIndex={2}
        ></AnimationWithSound>
      )}
      {capturedImage === CAPTURED_IMAGE.EXCELLENT && (
        <AnimationWithSound
          imageUrl={images['play-excellent.png']}
          soundFile={moreCaptureSound}
          playSound={!config.isMutedSound}
          zIndex={2}
        ></AnimationWithSound>
      )}
      {capturedImage === CAPTURED_IMAGE.FANTASTIC && (
        <AnimationWithSound
          imageUrl={images['play-fantastic.png']}
          soundFile={moreCaptureSound}
          playSound={!config.isMutedSound}
          zIndex={2}
        ></AnimationWithSound>
      )}
      {isResigned && (
        <AnimationWithSound
          imageUrl={images['play-resign.png']}
          soundFile={resingSound}
          playSound={!config.isMutedSound}
          style={{ zIndex: 2 }}
          onSoundEnd={() => {
            resingEnd();
          }}
        ></AnimationWithSound>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 1920px;
  height: 1080px;
`;

const Background = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  position: absolute;
  object-fit: contain;
`;

const PlayBlock = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
  z-index: ${(props) => props.$zIndex};
`;

const FullScreenImage = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: ${(props) => props.$zIndex};
`;

const Board = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: ${(props) => props.$zIndex};
`;

const RunButton = styled(ImgClick)`
  position: absolute;
  left: 28px;
  top: 16px;
  z-index: 1;
  visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};
`;

const UndoButton = styled(ImgClick)`
  position: absolute;
  left: 870px;
  top: 0px;
`;

const PlayerPass = styled.img`
  position: absolute;
  bottom: 300px;
  left: 200px;
`;

const BossPass = styled.img`
  position: absolute;
  bottom: 300px;
  right: 200px;
`;

const mapStateToProps = ({ student, config, hatchEgg }) => ({
  student,
  config,
  stageNumber: hatchEgg.stageNumber,
  playId: hatchEgg.playId,
  birdEnergy: hatchEgg.birdEnergy,
  // playState: hatchEgg.playState,
});

// export default connect(mapStateToProps, { backToMainPage, setPlayState })(
export default connect(mapStateToProps, { backToMainPage, setBirdEnergy })(
  PlayPage,
);
